import React, {memo} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {ROUTES} from '../../../configs/routes';
import './HeaderCart.less';
import {t} from '../../../services/i18nHandler';

const HeaderCart = ({cartData, user}) => {
  const userId = user._id;
  const userCartData = cartData[userId] || [];
  return (
    <div className="right-panel-item card-wrap">
      <Link to={ROUTES.CART.route} className="top-nav_link card-link" title={t('nav.cart')}>
        <span className="card-icon simple" />
        {userCartData.length ? <div className="cart-count">{userCartData.length}</div> : ''}
      </Link>
    </div>
  );
};

HeaderCart.defaultProps = {
  cartData: {},
  user: {},
};

HeaderCart.propTypes = {
  cartData: PropTypes.shape({}),
  user: PropTypes.shape({}),
};

function mapStateToProps({rCart, rUser}) {
  return {
    cartData: rCart.cartData,
    user: rUser,
  };
}

export default connect(mapStateToProps, null)(memo(HeaderCart));
